import { computed, ref, Ref } from "vue";
import { Delivery } from "../../domain/deliveries";

const emptyDelivery: Delivery = {
  deliveryId: "",
  client: "",
  name: "",
  message: "",
  approvedFiles: "",
  rejectedFiles: "",
  deliveryDate: ""
};

const memoryDelivery: Ref<Delivery> = ref(emptyDelivery);

export function deliveryStore() {
  async function updateDeliverySession(newArtwork: Delivery) {
    memoryDelivery.value = newArtwork;
  }

  function reset(): void {
    memoryDelivery.value = emptyDelivery;
  }

  function matchArtwork(deliveryId: string): boolean {
    return deliveryId === memoryDelivery.value.deliveryId;
  }

  const isEmpty = computed(() => {
    return memoryDelivery.value.deliveryId === emptyDelivery.deliveryId;
  });

  return {
    updateDeliverySession,
    isEmpty,
    memoryDelivery: memoryDelivery.value,
    reset,
    matchArtwork,
  };
}
